export default __webpack_public_path__ + "static/media/ic_sensor_white.dcffa21d.png";